/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-danger */
import { Select, Spin } from 'antd'
import { setGetListCollection } from 'hooks/setGetListCollection'
import { setGetListNFT } from 'hooks/setGetListNFT'
import { useRouter } from 'next/router'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { Box } from 'widgets/Box'
import { Link } from 'widgets/Link'
import { SearchIcon } from 'widgets/Svg'
import Avatar from 'components/Avatar'
import { setGetSearch } from 'hooks/setGetSearch'
import { debounce } from 'utils/debounce'

const Wrapper = styled.div`
  position: relative;

  &:not(.is-scroll) {
    .content {
      .ant-select-selection-item {
        color: #fff;

        a {
          p {
            color: #fff;
          }
        }
      }
    }
  }

  .bg {
    height: 50px;
    img {
      height: 100%;
    }
  }
  .content {
    position: relative;

    .input-search {
      min-height: 36px;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 15px;
      padding: 4px 8px;
      background: transparent;
      border: none;
      width: 100%;
      outline: none;
      padding-left: 30px;
    }

    .ant-select {
      position: absolute;
      z-index: -1;
      left: 0;
    }

    .ant-select:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input {
      outline: none;
      box-shadow: none;
      padding: 0 0 0 30px;
    }

    .ant-select-selection-placeholder {
      padding: 0 0 0 30px;
    }

    .ant-select-selection-item {
      padding: 0 0 0 30px;
      display: none;

      p {
        img {
          display: none;
        }
      }
    }

    .ant-select-arrow {
      display: none;
    }

    svg {
      position: absolute;
      top: 50%;
      left: 18px;
      transform: translateY(-50%);
      fill: transparent;
    }
  }

  .select-search {
    width: 100%;
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    background-color: transparent;
    border: none;
    outline: none;
    box-shadow: none;
  }

  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: none;
    outline: none;
    box-shadow: none;
  }

  .ant-select-clear {
    background: transparent;
    transform: translateY(-29%);
  }

  .ant-select-selection-item {
    p {
      span {
        b {
          font-weight: 400;
        }
      }
    }
  }
`

function SearchInput({ className, onClick, isScroll, refContainerDropdown, isMobile, ...props }: any) {
  const router = useRouter()

  const inputRef = useRef<any>(null)

  const [dataSearch, setDataSearch] = useState<any>()
  const [loading, setLoading] = useState<boolean>(false)
  const [valueSearch, setvalueSearch] = useState<string>('')

  const [parameSearch, setParameSearch] = useState<any>({ keyword: '', limit: 5, isGetAll: false })

  useEffect(() => {
    setGetSearch(
      parameSearch,
      (data) => {
        setDataSearch(data)
        setLoading(false)
      },
      () => setLoading(false),
    )
  }, [parameSearch])

  const makeBold = (item) => {
    const re = new RegExp(parameSearch.keyword, 'gi')

    return item?.replace(re, (match) => `<b style="display: contents;">${match}</b>`)
  }

  const handleSearch = debounce((e) => {
    setParameSearch((prev) => ({
      ...prev,
      keyword: e,
    }))
  }, 2000)

  const [isFocused, setIsFocused] = useState(false)

  const handleBlur = () => {
    const timeFocused = setTimeout(() => {
      setIsFocused(false)
    }, 1000)

    setTimeout(() => {
      if (inputRef.current === document.activeElement) {
        clearTimeout(timeFocused)
      }
    }, 500)
  }

  const handleFocus = () => {
    setIsFocused(true)
  }
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      if (dataSearch?.users?.length === 1) {
        router.push(`/account/address/${dataSearch.users[0].walletAddress}`, undefined, { scroll: false })
      }
      if (dataSearch?.collections?.length === 1) {
        router.push(`/collection/detail/${dataSearch.collections[0].id}`, undefined, { scroll: false })
      }
      if (dataSearch?.nfts?.length === 1) {
        router.push(`/nft/detail/${dataSearch.nfts[0].id}`, undefined, { scroll: false })
      }
    }
  }

  return (
    <Wrapper className={`${[className].join(' ')} ${isScroll ? 'is-scroll' : ''}`}>
      <Box className="content">
        <input
          className="input-search"
          type="text"
          onBlur={handleBlur}
          onFocus={handleFocus}
          onChange={(e) => {
            handleSearch(e?.target?.value)
            setLoading(true)
            setvalueSearch(e?.target?.value)
            handleFocus()
          }}
          onKeyDown={handleKeyDown}
          placeholder="Search items, collections, account..."
          value={valueSearch}
          ref={inputRef}
        />
        <Select
          className="select-search"
          listHeight={376}
          getPopupContainer={() => refContainerDropdown?.current}
          open={isFocused}
          onClick={handleFocus}
        >
          {!loading ? (
            <>
              {dataSearch?.users?.length > 0 && (
                <Select.OptGroup label="Account">
                  {dataSearch?.users?.map((item) => {
                    return (
                      <Select.Option key={`account-${item.id}`} value={item.id}>
                        <Link href={`/account/address/${item.walletAddress}`} style={{ width: '100%' }}>
                          <div className="wrap-account">
                            <Avatar
                              avatar={item.profile.avatar || '/images/account/avatar-image-default.png'}
                              height="23px"
                              width="23px"
                              transform="scale(0.2091) translate(-175%, -189%)"
                            />
                            <p>
                              <span dangerouslySetInnerHTML={{ __html: makeBold(item.profile.displayName) }} />
                            </p>
                          </div>
                        </Link>
                      </Select.Option>
                    )
                  })}
                </Select.OptGroup>
              )}

              {dataSearch?.collections?.length > 0 && (
                <Select.OptGroup label="Collections">
                  {dataSearch?.collections?.map((item) => {
                    return (
                      <Select.Option key={`collection-${item.id}`} value={item.id}>
                        <Link href={`/collection/detail/${item.id}`} style={{ width: '100%' }}>
                          <p>
                            <img
                              style={{ borderRadius: '5px' }}
                              src={item.image || item.animationUrl}
                              alt={item.name}
                            />
                            <span style={{ display: 'none' }}>{item.name}</span>
                            <span dangerouslySetInnerHTML={{ __html: makeBold(item.name) }} />
                          </p>
                        </Link>
                      </Select.Option>
                    )
                  })}
                </Select.OptGroup>
              )}

              {dataSearch?.nfts?.length && (
                <Select.OptGroup label="NFT">
                  {dataSearch?.nfts?.map((item) => {
                    return (
                      <Select.Option key={`nft-${item.id}`} value={item.id}>
                        <Link href={`/nft/detail/${item.id}`} style={{ width: '100%' }}>
                          <p>
                            {item?.moreInfo?.itemType === 'video/mp4' ? (
                              <video width="23px" autoPlay muted loop playsInline>
                                <source src={item.animationUrl} type="video/mp4" />
                              </video>
                            ) : (
                              <img
                                style={{ borderRadius: '5px' }}
                                src={item.image || item.animationUrl}
                                alt={item.name}
                              />
                            )}

                            <span style={{ display: 'none' }}>{item.name}</span>
                            <span dangerouslySetInnerHTML={{ __html: makeBold(item.name) }} />
                          </p>
                        </Link>
                      </Select.Option>
                    )
                  })}
                </Select.OptGroup>
              )}

              {!parameSearch?.keyword && (
                <Select.OptGroup label="Trending Search">
                  {dataSearch?.trendingSearch?.map((item: any) => (
                    <Select.Option value={item.keyword} key={`trending-search${item?.keyword}`}>
                      <p
                        onClick={() => {
                          setIsFocused(true)
                          setLoading(true)
                          handleSearch(item?.keyword)
                          setvalueSearch(item?.keyword)
                          inputRef.current.focus()
                        }}
                      >
                        <img src="/images/icons/icon-search-search.svg" alt={item.keyword} />
                        {item?.keyword}
                      </p>
                    </Select.Option>
                  ))}
                </Select.OptGroup>
              )}
            </>
          ) : (
            <div>
              <Spin style={{ display: 'block', margin: 'auto' }} />
            </div>
          )}
        </Select>
        <div role="button" tabIndex={0} className="button-clear" onClick={() => handleSearch('')}>
          <SearchIcon
            onClick={onClick}
            isMobile={isMobile}
            isSearch={parameSearch}
            fill={isScroll ? '#006DFE' : '#ffffff'}
          />
        </div>
      </Box>
    </Wrapper>
  )
}

SearchInput.defaultProps = {
  className: '',
  onClick: () => null,
}

export default SearchInput
